import { AxiosError } from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { adminActions, IAdminEnrollment, IAdminResource, resetApiCaches } from '@/entities/Admin';
import { ThunkConfig } from '@/shared/types/store';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { RejectApiResponse, SuccessApiResponse } from '@/shared/types/common';

interface IAuthByEmailProps {
  email: string;
  password: string;
  clientType?: 'admin';
}

interface IAuthResponse {
  jwt: string;
  user: IAdminResource;
  enrollments: IAdminEnrollment[];
}

export const authByEmail = createAsyncThunk<
  void,
  IAuthByEmailProps,
  ThunkConfig<RejectApiResponse>
>('auth', async (authData, thunkAPI) => {
  const { extra, rejectWithValue } = thunkAPI;

  try {
    const response = await extra.api.post<SuccessApiResponse<IAuthResponse>>(
      '/auth/login',
      { ...authData, clientType: 'admin' },
    );

    const {
      jwt: accessToken,
      user: { id, firstName, lastName, email },
    } = response.data.data;

    if (accessToken) {
      LocalStorageService.setAccessToken(accessToken);
    }

    if (typeof window !== 'undefined') {
      const shortUser = {
        userId: id.toString(),
        firstName,
        lastName,
        email,
      };

      localStorage.setItem('user', JSON.stringify(shortUser));
    }

    resetApiCaches();
    thunkAPI.dispatch(adminActions.setProfile(null));
    thunkAPI.dispatch(adminActions.setIsAuth(true));
  } catch (e) {
    const error = e as AxiosError<any>;
    const errorData: RejectApiResponse = error.response?.data;

    return rejectWithValue(errorData || {});
  }
});
